import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

// Shared "How OTA Commands Work" trigger + modal, dropped into any page
// that deals with OTA (Manual OTA, OTA Batch Create/List/View) so the
// explanation only has to be maintained in one place. Content is traced
// against the device-side command dispatch/completion logic (tcu4g_ota)
// and the admin backend's creation/abort endpoints - see the diagrams'
// own captions for the specific behavior each box/arrow reflects.
@Component({
  selector: 'app-ota-info',
  standalone: true,
  imports: [MatIcon, MatTooltip],
  templateUrl: './ota-info.component.html',
  styleUrl: './ota-info.component.scss',
})
export class OtaInfoComponent {
  isOpen = false;

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  // See fota-info.component.ts for why window.print() (not a PDF library).
  exportPdf(): void {
    window.print();
  }
}
